import { last } from 'ramda';

import { EStepCode } from '../../types/requestFormSchema';
import { TThunkAction } from '../../types/redux';
import { setCurrentStep } from './actionts';
import { TRequestFormCallbackProps } from '../../types/requestForm';

export const handlePrevStep =
  (props: TRequestFormCallbackProps): TThunkAction =>
  dispatch => {
    const nextStep = last(props.stepsHistory);
    if (nextStep) {
      dispatch(setCurrentStep(nextStep.code as EStepCode));
    }
  };
